import { ReactElement } from 'react';
import { GroupBase, MultiValueGenericProps } from 'react-select';

export function MultiValue<T>(
  { children, data }: MultiValueGenericProps<T, boolean, GroupBase<T>>,
  customMultiValue?: (data: T) => ReactElement | null
): ReactElement | null {
  if (customMultiValue) return customMultiValue(data);
  return <p>{children}</p>;
}
